import { render, staticRenderFns } from "./ViewSelectedDetail.vue?vue&type=template&id=8c12c822&scoped=true&"
import script from "./ViewSelectedDetail.vue?vue&type=script&lang=js&"
export * from "./ViewSelectedDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewSelectedDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewSelectedDetail.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ViewSelectedDetail.vue?vue&type=style&index=2&id=8c12c822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c12c822",
  null
  
)

export default component.exports